var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoundCheckFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 23.1796 23.1796 29 16 29C8.82029 29 3 23.1796 3 16C3 8.82029 8.82029 3 16 3C23.1796 3 29 8.82029 29 16ZM21.2394 12.0606C21.6202 12.4413 21.6202 13.0587 21.2394 13.4394L14.7394 19.9394C14.3586 20.3202 13.7414 20.3202 13.3606 19.9394L10.7606 17.3394C10.3798 16.9586 10.3798 16.3414 10.7606 15.9606C11.1413 15.5798 11.7587 15.5798 12.1394 15.9606L14.05 17.8711L16.9552 14.9658L19.8606 12.0606C20.2414 11.6798 20.8586 11.6798 21.2394 12.0606Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundCheckFilled);
export default __webpack_public_path__ + "static/media/icon-round-check-filled.29bfb6628e00d6214c38663dc70ee565.svg";
export { ForwardRef as ReactComponent };